import { render, staticRenderFns } from "./NewJob.vue?vue&type=template&id=70a28116&scoped=true&"
import script from "./NewJob.vue?vue&type=script&lang=js&"
export * from "./NewJob.vue?vue&type=script&lang=js&"
import style0 from "./NewJob.vue?vue&type=style&index=0&id=70a28116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a28116",
  null
  
)

export default component.exports